import type { GeneralResp } from '@/models/GeneralResp';
import type { AxiosResponse } from 'axios';
import * as ApiClient from '@/libs/ApiClient';
import { RouteUrlList } from '@/libs/RouteList';
import type { CountryRow, CityRow } from '@/libs/AddressHelper';
import type { IDCheck_P_Row, IDCheck_T_Row } from '@/components/7_FillBasicData/IDCheckHelper';
/**
 * @todo 初始化設定值
 */
export interface FillBasicDataViewDataResp extends GeneralResp {
    result: ViewResult;
}

interface ViewResult {
    cname: string;

    birthday: string;
    ssn: string;
    sex: string;
    education: string;
    educationOther:string;

    // 身分證資訊
    isLockIDCheck: boolean; // 換補領OCR 正確則鎖定 發證地點+領補換類別
    iDCheck_P_Collection: Array<IDCheck_P_Row>; // 發證地點
    iDCheck_T_Collection: Array<IDCheck_T_Row>; // 領補換類別
    iDCheck_Y_Collection: Array<string>; // 身分證發證日期 Y
    iDCheck_M_Collection: Array<string>; // 身分證發證日期 M
    iDCheck_D_Collection: Array<string>; // 身分證發證日期 D

    iDCheck_P: string; // 發證地點
    iDCheck_T: string; // 領補換類別
    iDCheck_Y: string; // 身分證發證日期 Y
    iDCheck_M: string; // 身分證發證日期 M
    iDCheck_D: string; // 身分證發證日期 D

    countryOfBirthList: Array<CountryRow>;

    commonCityData: CityRow[];

    domicileCode: string;
    domicileAddressCity: string;
    domicileAddressDist: string;
    domicileAddressRoad: string;

    mailingAddressCode: string;
    mailingAddressCity: string;
    mailingAddressDist: string;
    mailingAddressRoad: string;

    homeAddressCode: string;
    homeAddressCity: string;
    homeAddressDist: string;
    homeAddressRoad: string;

    contactExt: string;
    contactTelephone: string;
    emergencyContactRelation: string;
    emergencyContactRelationOther: string;
    emergencyContact: string;
    emergencyContactPhone: string;
    mobilephone: string;
    mobilephoneOtpBaseData: OtpBaseData;
    email: string;
    emailOtpBaseData: OtpBaseData;
}

import type { IUserInput } from '@/models/DTO/CommonModels';

export interface OtpBaseData {
    isVerified: boolean; // Email 是否已被驗證
    isInSendStatus: boolean; // 是否處於發送間隔內
    isInWaitToSendAgain: boolean; // false 是否處於驗證失敗次數過多等候發送間隔內
    timeCountSec: number; // 總倒數時秒數
    nowLeftSec: number; // 目前倒數秒數
    sendCount: number; // 發送次數
    verifySendCount: number; // 驗證碼發送次數
    codeLetter: string; // 驗證碼前綴
    inSendIntervalMessage: string; // 相同信箱於時間內頻繁申請，請稍候5分鐘
    reachedVerifyMaxTryMessage: string; // 驗證次數已達上限
}

/**
 * @todo 出入金帳號約定/證明文件上傳 ViewData
 */
const FillBasicDataViewData = (): Promise<FillBasicDataViewDataResp> => {
    const url = RouteUrlList.API_FillBasicDataViewData.path;
    const config = {
        params: { showOverlay: ApiClient.paramTypeEnum.true, getServiceAlert: ApiClient.paramTypeEnum.true }
    };
    return ApiClient.post(url, {}, config).then((res: AxiosResponse<FillBasicDataViewDataResp>) => {
        return res.data;
    });
};

export default FillBasicDataViewData;
